import React from "react"
import { Flex, Text, TextLink } from "@indeed/ifl-components"
import { useQueryParams } from "../../../common/hooks/hooks"
import { FromParam } from "../../../common/models/query-params"
import { configSelector } from "../../../common/utils/config-slice"
import { useI18n } from "../../../common/utils/i18n-context"
import { useAppSelector } from "../../../common/utils/redux-helpers"
import { parseEssentialQueryParams } from "../../../common/utils/utils"

export const PauseEntry: React.FC = () => {
    const encryptedInfo = parseEssentialQueryParams(useQueryParams()).info
    const config = useAppSelector(configSelector)
    const { gettext } = useI18n()

    return (
        <Flex
            sx={{
                flexDirection: "column",
                inlineSize: ["100%", "35.625rem"],
                marginBlockEnd: "auto",
                marginBlockStart: 4,
                marginInlineStart: "auto",
                marginInlineEnd: "auto",
                textAlign: "center",
            }}
        >
            <Text level={2}>{gettext("No longer looking for a job?")}</Text>
            <Text level={2}>
                <TextLink href={`${config.pauseUrl}?info=${encryptedInfo}&from=${FromParam.FEEDBACK_PAGE}`}>
                    {gettext("Pause Job Match communications")}
                </TextLink>
            </Text>
        </Flex>
    )
}
